import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

import SaleLayout from '../layouts/SaleLayout.vue'
import Dashboard from '../views/sale/Dashboard.vue'
import Profile from '../views/sale/Profile.vue'
import Summary from '../views/sale/Summary.vue'
import CallHistory from '../views/sale/CallHistory.vue'

import AdminLayout from '../layouts/AdminLayout.vue'
import AdminDashboard from '../views/admin/Dashboard.vue'
import EmployeeManager from '../views/admin/EmployeeManager.vue'
import ImportPage from '../views/admin/ImportPage.vue'
import CustomerList from '../views/admin/CustomerList.vue'
import OrderPage from '../views/admin/OrderPage.vue'
import ReportPage from '../views/admin/ReportPage.vue'
import EditAdmin from '../views/admin/EditAdmin.vue'
import ImportHistory from '../views/admin/ImportHistory.vue';

import CustomerDetail from '../views/sale/CustomerDetail.vue';

import msg from '@/i18n/index'
import DataManager from "../views/admin/DataManager";
import SendZns from '../views/admin/SendZns.vue';
import ZnsHistory from '../views/admin/ZnsHistory.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    meta: { title: 'login' },
    component: Login
  },
  {
    path: '/sale',
    meta: { requiresAuth: true, title: 'sales' },
    component: SaleLayout,
    children: [
      { path: "", component: Dashboard },
      { path: "profile", component: Profile },
      { path: "summary", component: Summary },
      { path: "history", component: CallHistory },
      { path: "customer/:id", component: CustomerDetail },
    ]
  },
  {
    path: '/admin',
    meta: { requiresAuth: true, title: 'admin' },
    redirect: '/admin/dashboard',
    component: AdminLayout,
    children: [
      { path: "dashboard", component: AdminDashboard },
      { path: "employee", component: EmployeeManager, meta: { title: 'employee' } },
      { path: "customer", component: CustomerList, meta: { title: 'order' } },
      { path: "edit", component: EditAdmin, meta: { title: 'edit' } },
      { path: "order", component: OrderPage, meta: { title: 'order' } },
      { path: "import", component: ImportPage, meta: { title: 'importPage' } },
      { path: "data", component: DataManager, meta: { title: 'dataManager' } },
      { path: "report", component: ReportPage, meta: { title: 'reportPage' } },
      { path: "import-history", component: ImportHistory, meta: { title: 'importHistory' } },
      { path: "send-zns", component: SendZns, meta: { title: 'sendZns' } },
      { path: "zns-history", component: ZnsHistory, meta: { title: 'znsHistory' } },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const locale = store.getters.locale;
  let t;
  if (locale == 'vi') {
    t = msg.messages.vi;
  } else if (locale == 'en') {
    t = msg.messages.en;
  }

  if (to.meta.title) {
    document.title = t.title[to.meta.title]
  } else {
    let parentRoute = to.matched[0]
    if (parentRoute && parentRoute.meta.title) {
      document.title = t.title[parentRoute.meta.title]
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isLogin) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
